/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IPropertySchema } from '../../core/models/common/IPropertySchema';
import { Schema } from '../../core/models/common/Schema';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Node } from '../../core/models/Node';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';

/**
 * A command used to rename a schema definition, along with all references to it.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class RenameSchemaDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public _messageReferences : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._messageReferences===undefined) this._messageReferences = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._messageReferences===undefined) this._messageReferences = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._messageReferences===undefined) this._messageReferences = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._messageReferences===undefined) this._messageReferences = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameSchemaDefinitionCommand] Executing.");
        this._references = <any>([]);
        this._messageReferences = <any>([]);
        if(this._renameSchemaDefinition(document, this._oldName, this._newName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            let newRef : string = this._nameToReference(this._newName);
            let schemaFinder : RenameSchemaDefinitionCommand.SchemaRefFinder = new RenameSchemaDefinitionCommand.SchemaRefFinder(oldRef);
            let referenceHolder : RenameSchemaDefinitionCommand.SchemaRefFinder.ReferenceHolder = schemaFinder.findIn(document);
            {
                let array157 = referenceHolder.getSchemas();
                for(let index156=0; index156 < array157.length; index156++) {
                    let schema = array157[index156];
                    {
                        /* add */(this._references.push(Library.createNodePath(schema))>0);
                        schema.$ref = newRef;
                    }
                }
            }
            {
                let array159 = referenceHolder.getMessages();
                for(let index158=0; index158 < array159.length; index158++) {
                    let aaiMessage = array159[index158];
                    {
                        /* add */(this._messageReferences.push(Library.createNodePath(aaiMessage))>0);
                        JsonCompat.setPropertyString(aaiMessage.payload, "$ref", newRef);
                    }
                }
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameSchemaDefinitionCommand] Reverting.");
        if(this._renameSchemaDefinition(document, this._newName, this._oldName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let schema : Schema = <Schema>ref.resolve(document);
                        schema.$ref = oldRef;
                    }
                })(oldRef));
            }
            if(ModelUtils.isDefined(this._messageReferences)) {
                this._messageReferences.forEach(((oldRef) => {
                    return (ref) => {
                        let aaiMessage : AaiMessage = <AaiMessage>ref.resolve(document);
                        JsonCompat.setPropertyString(aaiMessage.payload, "$ref", oldRef);
                    }
                })(oldRef));
            }
        }
    }

    /**
     * Convert a simple name to a reference.  This will be different for 2.0 vs. 3.0
     * data models.
     * @param {string} name
     * @return {string}
     */
    abstract _nameToReference(name : string) : string;

    /**
     * Called to actually change the name of the schema definition.  This impl will vary
     * depending on the OAI data model version.  Returns true if the rename actually happened.
     * @param {Document} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    abstract _renameSchemaDefinition(document : Document, fromName : string, toName : string) : boolean;
}
RenameSchemaDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand";
RenameSchemaDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameSchemaDefinitionCommand {

    /**
     * Constructor.
     * @param {string} reference
     * @class
     * @extends CombinedVisitorAdapter
     */
    export class SchemaRefFinder extends CombinedVisitorAdapter {
        _reference : string;

        referenceHolder : SchemaRefFinder.ReferenceHolder = new SchemaRefFinder.ReferenceHolder();

        public constructor(reference : string) {
            super();
            if(this._reference===undefined) this._reference = null;
            this._reference = reference;
        }

        public findIn(document : Document) : SchemaRefFinder.ReferenceHolder {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this.referenceHolder;
        }

        public _accept$io_apicurio_datamodels_core_models_common_Schema(schema : Schema) : boolean {
            return ModelUtils.isDefined(schema.$ref) && NodeCompat.equals(schema.$ref, this._reference);
        }

        public _accept(schema? : any) : any {
            if(((schema != null && schema instanceof <any>Schema) || schema === null)) {
                return <any>this._accept$io_apicurio_datamodels_core_models_common_Schema(schema);
            } else if(((schema != null && schema instanceof <any>AaiMessage) || schema === null)) {
                return <any>this._accept$io_apicurio_datamodels_asyncapi_models_AaiMessage(schema);
            } else throw new Error('invalid overload');
        }

        _accept$io_apicurio_datamodels_asyncapi_models_AaiMessage(message : AaiMessage) : boolean {
            return ModelUtils.isDefined(message.payload) && NodeCompat.equals(JsonCompat.getPropertyString(message.payload, "$ref"), this._reference);
        }

        processSchema(schema : Schema) {
            if(this._accept$io_apicurio_datamodels_core_models_common_Schema(schema)) {
                this.referenceHolder.addSchema(schema);
            }
        }

        processMessage(message : AaiMessage) {
            if(this._accept$io_apicurio_datamodels_asyncapi_models_AaiMessage(message)) {
                this.referenceHolder.addMessage(message);
            }
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
         * @param {Schema} node
         */
        public visitSchema(node : Schema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
         * @param {*} node
         */
        public visitSchemaDefinition(node : IDefinition) {
            this.processSchema(<Schema><any>node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitPropertySchema(io.apicurio.datamodels.core.models.common.IPropertySchema)
         * @param {*} node
         */
        public visitPropertySchema(node : IPropertySchema) {
            this.processSchema(<Schema><any>node);
        }

        public visitAdditionalPropertiesSchema$io_apicurio_datamodels_openapi_models_OasSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAdditionalPropertiesSchema(node? : any) : any {
            if(((node != null && node instanceof <any>OasSchema) || node === null)) {
                return <any>this.visitAdditionalPropertiesSchema$io_apicurio_datamodels_openapi_models_OasSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitAdditionalPropertiesSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitAllOfSchema$io_apicurio_datamodels_openapi_models_OasSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAllOfSchema(node? : any) : any {
            if(((node != null && node instanceof <any>OasSchema) || node === null)) {
                return <any>this.visitAllOfSchema$io_apicurio_datamodels_openapi_models_OasSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitAllOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitItemsSchema$io_apicurio_datamodels_openapi_models_OasSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitItemsSchema(node? : any) : any {
            if(((node != null && node instanceof <any>OasSchema) || node === null)) {
                return <any>this.visitItemsSchema$io_apicurio_datamodels_openapi_models_OasSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitItemsSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitAnyOfSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30AnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
         * @param {Oas30Schema.Oas30AnyOfSchema} node
         */
        public visitAnyOfSchema(node? : any) : any {
            if(((node != null && node instanceof <any>Oas30Schema.Oas30AnyOfSchema) || node === null)) {
                return <any>this.visitAnyOfSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30AnyOfSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitAnyOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitOneOfSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30OneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
         * @param {Oas30Schema.Oas30OneOfSchema} node
         */
        public visitOneOfSchema(node? : any) : any {
            if(((node != null && node instanceof <any>Oas30Schema.Oas30OneOfSchema) || node === null)) {
                return <any>this.visitOneOfSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30OneOfSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitOneOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitNotSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30NotSchema(node : Oas30Schema.Oas30NotSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
         * @param {Oas30Schema.Oas30NotSchema} node
         */
        public visitNotSchema(node? : any) : any {
            if(((node != null && node instanceof <any>Oas30Schema.Oas30NotSchema) || node === null)) {
                return <any>this.visitNotSchema$io_apicurio_datamodels_openapi_v3_models_Oas30Schema_Oas30NotSchema(node);
            } else if(((node != null && node instanceof <any>AaiSchema) || node === null)) {
                return <any>this.visitNotSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node);
            } else throw new Error('invalid overload');
        }

        public visitAllOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        public visitOneOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        public visitAnyOfSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        public visitNotSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        public visitItemsSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        public visitAdditionalPropertiesSchema$io_apicurio_datamodels_asyncapi_models_AaiSchema(node : AaiSchema) {
            this.processSchema(node);
        }

        /**
         * Payloads from AaiMessage are not visitable (typed as {@link Object}) and therefore need a bit of manipulation
         * to retrieve their $references
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitMessage(io.apicurio.datamodels.asyncapi.models.AaiMessage)
         * @see io.apicurio.datamodels.asyncapi.models.AaiMessage#payload
         * @param {AaiMessage} node
         */
        public visitMessage(node : AaiMessage) {
            this.processMessage(node);
        }
    }
    SchemaRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand.SchemaRefFinder";
    SchemaRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];



    export namespace SchemaRefFinder {

        export class ReferenceHolder {
            schemas : Array<Schema> = <any>([]);

            messages : Array<AaiMessage> = <any>([]);

            /**
             * @return {Schema[]} the schemas
             */
            public getSchemas() : Array<Schema> {
                return this.schemas;
            }

            /**
             * @return {AaiMessage[]} the aaiMessages
             */
            public getMessages() : Array<AaiMessage> {
                return this.messages;
            }

            public addSchema(schema : Schema) {
                /* add */(this.schemas.push(schema)>0);
            }

            public addMessage(aaiMessage : AaiMessage) {
                /* add */(this.messages.push(aaiMessage)>0);
            }

            constructor() {
            }
        }
        ReferenceHolder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand.SchemaRefFinder.ReferenceHolder";

    }

}



